module.exports = __webpack_public_path__ + "img/c20.776e6811.png";